import _orderBy from 'lodash.orderby';
import { offset, TABLE_IDS } from '../constants';

// Create full-text search query string
export const createSearchQueryString = (searchFields, filterText) => {
  let searchString = '';
  if (filterText) {
    searchFields.forEach((field, index) => {
      searchString = searchString.concat(
        `${field}:*${filterText}*${
          searchFields.length - 1 !== index ? ' OR ' : ''
        }`
      );
    });
  }
  return searchString;
};

export const searchFilterTableRows = (data, searchText, searchFields) => {
  return data.filter((obj) => {
    // TODO Refactor for loop
    // eslint-disable-next-line no-restricted-syntax
    for (const prop in obj) {
      if (
        searchFields.includes(prop) &&
        obj[prop] &&
        obj[prop].toLowerCase().includes(searchText.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  });
};

export const sortTableRows = (data, sort) => {
  let sortedArray = [];
  if (sort) {
    const [type, order] = sort.split(':');
    sortedArray = _orderBy(data, [type], order === '1' ? 'asc' : 'desc');
  }
  return sortedArray.length > 0 ? sortedArray : data;
};

export const paginateTableRows = (data, page, offset) => {
  return data.slice((page - 1) * offset, page * offset);
};

export const filterTableRows = (
  data,
  searchText,
  searchFields,
  sort,
  page,
  offset
) => {
  const searchedData = searchFilterTableRows(data, searchText, searchFields);
  const sortedData = sortTableRows(searchedData, sort);

  return [paginateTableRows(sortedData, page, offset), sortedData.length];
};

export const createInitialTableMetaData = () => {
  const result = {};
  Object.keys(TABLE_IDS).forEach((key) => {
    result[key] = {
      page: 1,
      search: '',
      sort: 'createdAt_desc',
      sizePerPage: offset,
    };
  });
  return result;
};
